import axios, { AxiosError, AxiosRequestConfig, AxiosResponse, Method } from 'axios';

import authService from '@app/libs/auth/authService';

import {
  create401HTTPResponseError,
  createHTTPHeaders,
  createIEBrowserCacheDisabledParam,
  getJSONWebToken,
  isExistJSONWebToken,
} from './utils';

interface RequestAPIParam extends AxiosRequestConfig {
  bypass401?: boolean;
  credentials?: boolean;
  disableIEBrowserCache?: boolean;
  method: Method;
  jwt?: string;
  url: string;
}

export async function requestApi<T = unknown>({
  credentials = false,
  disableIEBrowserCache = true,
  headers,
  method,
  params,
  jwt,
  url,
  ...config
}: RequestAPIParam): Promise<AxiosResponse<T>> {
  let token: string | null = null;
  if (credentials) {
    if (!isExistJSONWebToken(jwt)) {
      const error = create401HTTPResponseError('authorization token not found');
      return Promise.reject(error);
    }
    if (!jwt) {
      await authService.refreshTokens();
    }
    token = getJSONWebToken(jwt);
  }

  return axios
    .request<T>({
      ...config,
      url,
      method,
      headers: createHTTPHeaders(headers, url, credentials, token as string, config.baseURL),
      params: createIEBrowserCacheDisabledParam(method, params, disableIEBrowserCache),
    })
    .then(
      (response) => response,
      (error: AxiosError) => {
        if (error.response) {
          Object.assign(error, {
            message: error.response.data?.message || '',
            response: error.response,
          });
        }
        return Promise.reject(error);
      }
    );
}
